import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Secciones/Header';
import Footer from '../components/Secciones/Footer';
import SignupForm from '../components/Signup/SignupForm';
import { UserAuthContext } from '../UserAuthContext';

const Signup = () => {  
  const { user, loading } = useContext(UserAuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && user) {
      navigate(location.state?.returnTo || '/', { replace: true });
    }
  }, [user, loading, navigate, location.state]);

  if (loading) {
    return (
      <div>
        <Header />
        <main className="su-page"><div className="su-confirmation"><p>Checking your account…</p></div></main>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <SignupForm />
      <Footer />
    </div>
  );
};

export default Signup;
